import { OpenedEyeIcon } from "frontend/icons/opened-eye-icon";
import EditableText, { EditableTextStyle } from "frontend/ui-components/editable-text";
import { Board } from "shared/datamodel/schemas";
import style from "./board-title.module.css";
import { errorMessageAtom } from "state-atoms";
import { useSetAtom } from "jotai";
import { useBoardTitle } from "frontend/hooks/use-board-title";

interface BoardTitleProps {
  board: Board;
  isReadOnly: boolean;
  isAnonymous: boolean;
}

export default function BoardTitle({ board, isReadOnly, isAnonymous }: BoardTitleProps) {
  const [boardTitle, changeBoardTitle] = useBoardTitle();
  const setError = useSetAtom(errorMessageAtom);

  const editableTextExtraStyle = isAnonymous
    ? {}
    : {
        width: "calc(100vw - 830px)",
      };

  return (
    <div data-testid="boardnametext" className={style.boardTitleContainer}>
      <EditableText
        value={boardTitle}
        editable={board.isOwner}
        onChange={changeBoardTitle}
        textStyle={EditableTextStyle.header}
        onShowNonEditableMessage={() => setError("Only the canvas owner can change its name")}
        style={editableTextExtraStyle}
      />
      {isAnonymous && (
        <div className={style.anonymousTitleContainer}>
          {isReadOnly ? (
            <>
              <OpenedEyeIcon color="#7F869B" size={18} />
              <div className={style.anonymousTitle}>View only</div>
            </>
          ) : (
            <div className={style.anonymousTitle}>You’re a guest </div>
          )}
        </div>
      )}
    </div>
  );
}
